import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import styles from './FilterTypes.module.scss'

export default function FilterTypes({
  actives,
  types,
  callback,
  ordering = 'normal',
  setCurrentPage,
  activeIndex,
}) {
  if (actives === null) return null

  const { types: activeTypes } = actives

  const [indexToSend, setIndexToSend] = useState(activeIndex)
  const [typesToSend, setTypesToSend] = useState(activeTypes)

  const mainFiltersRef = useRef(null)

  const serviceIcons = [
    ['/img/search/rooms-pink.svg', '/img/search/rooms-gray.svg'],
    ['/img/search/activities-pink.svg', '/img/search/activities-gray.svg'],
    ['/img/search/catering-pink.svg', '/img/search/catering-gray.svg'],
    ['/img/search/mic-pink.svg', '/img/search/mic-gray.svg'],
    ['/img/search/other-pink.svg', '/img/search/other-gray.svg'],
  ]

  const toggleActiveType = (slug) => {
    if (activeTypes.includes(slug)) {
      setTypesToSend([])
    } else {
      setTypesToSend([slug])
    }
  }

  const handleMainFilterClick = (index, slug) => {
    if (index === activeIndex) {
      setIndexToSend(null)
      toggleActiveType(slug)
    } else {
      setIndexToSend(index)
      toggleActiveType(slug)
    }
  }

  const updateQuery = () => {
    const newQuery = []

    /**
     * Only reset pagination if user is the one making selections
     * Same action may be triggered by initial load of filters from store.
     */
    // const resetPagination = isManuallyOperated

    if (typesToSend.length > 0) {
      newQuery.push({
        filter: 'event_type',
        values: typesToSend,
      })
    }

    // callback(newQuery, resetPagination, activeOrderBy)
    if (indexToSend === undefined || indexToSend === null) {
      callback(newQuery, '', indexToSend)
    } else {
      callback(newQuery, types[indexToSend].name, indexToSend)
    }
  }

  const handleFadeOverlayClick = () => {
    // Check if mainFilters ref is defined
    if (mainFiltersRef.current) {
      // Scroll to the right-most side of the container
      mainFiltersRef.current.scrollTo({
        left: mainFiltersRef.current.scrollWidth,
        behavior: 'smooth', // for smooth scrolling
      })
    }
  }

  useEffect(() => {
    // When typesToSend changes, bring the page back to 1
    setCurrentPage(1)

    updateQuery()
  }, [typesToSend])

  return (
    <section>
      <div className={ordering === 'normal' && 'container'}>
        <div
          className={
            ordering === 'normal' ? styles.wrapper : styles.gridWrapper
          }
        >
          <h4
            className={
              ordering === 'normal' ? styles.title : styles.sectionHeading
            }
          >
            Valitse palvelutyyppi
          </h4>
          <div className={styles.fadeAndIconsWrapper}>
            {ordering !== 'grid' && (
              <div className={styles.fadeOverlay}>
                <div
                  onClick={handleFadeOverlayClick}
                  style={{
                    width: '40px',
                    height: '40px',
                    marginRight: '10px',
                    backgroundImage: `url(img/next-icon.svg)`,
                    backgroundSize: '60px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                  }}
                />
              </div>
            )}
            <div
              ref={mainFiltersRef}
              className={
                ordering === 'normal' ? styles.mainFilters : styles.gridFilters
              }
            >
              {types.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleMainFilterClick(index, item.slug)}
                    className={`${
                      ordering !== 'grid' && styles.filterElement
                    } ${
                      activeIndex === index &&
                      ordering === 'grid' &&
                      styles.gridActiveElement
                    } ${
                      activeIndex === index &&
                      ordering !== 'grid' &&
                      styles.activeElement
                    } ${ordering === 'grid' && styles.grid} ${
                      ordering === 'grid' && styles.gridFilterElement
                    }`}
                  >
                    <div>
                      <Image
                        src={serviceIcons[index][activeIndex === index ? 0 : 1]}
                        width="48"
                        height="48"
                      />
                    </div>
                    <div className={styles.mainFilterText}>{item.name}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
